// extracted by mini-css-extract-plugin
export default {"container":"Pp-z","heading":"Qp-z","text":"Rp-z","info":"Sp-z","link":"Tp-z","fullMaxWidth":"Up-z"};